import { render, staticRenderFns } from "./phoneForm.vue?vue&type=template&id=1f60cf80&scoped=true"
import script from "./phoneForm.vue?vue&type=script&lang=js"
export * from "./phoneForm.vue?vue&type=script&lang=js"
import style0 from "./phoneForm.vue?vue&type=style&index=0&id=1f60cf80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f60cf80",
  null
  
)

export default component.exports